/**
 * Created by chuongnv 2017/09/28.
 */
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";
import { ApiEvsService } from "../../../../common/services/ApiEvs.service";

@Injectable()
export class StampStatisticsService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint("");
  }

  //chuongnv:

  logScan(data?: any) {
    return this.get(`/logs/scan/statistic`, data);
  }

  // get all list stamp
  apiGetTotalStamps(data?: {}) {
    return this.get("/stamps/count", data);
  }

  listOrder(data?: any) {
    return this.get("/items_order", data);
  }

  getLogsScan(data?: any) {
    return this.get("/logs/scan", data);
  }

  getCountUserScan(data?: any) {
    return this.get("/g_customers/count", data);
  }

  getDashboardOverview() {
    return this.get("/dashboard/overview");
  }

  getDashboardOrders(data: any) {
    return this.get("/dashboard/orders", data);
  }
  getDashboardBatchs(data: any) {
    return this.get("/dashboard/batch_status", data);
  }
  getDashBoardStores(data: any) {
    // return this.get("/dashboard/store_status", data);
    return this.get("/qr_aps/dashboard/store/overflow", data);
  }
  getDashBoardOverflow(data: any) {
    return this.get("/qr_aps/dashboard/location", data);
  }
  getDashBoardCity(data: any) {
    return this.get("/dashboard/city_status", data);
  }
  getDashboardWarningStasitic(data) {
    return this.get("/dashboard/warning/statistic", data);
  }
  getDashboardWarnings(data: any) {
    return this.get("/dashboard/warning", data);
  }
  getDashboardWarningUseTime(data: any) {
    return this.get("/dashboard/warning-usage-time", data);
  }
  getDashboardScans(data: any) {
    return this.get("/dashboard/scan_status", data);
  }
  getDashboardScanLocation(data: any) {
    return this.get("/dashboard/scan_location", data);
  }
  getDashboardStatisticsWarning(data: any) {
    return this.get("/qr_aps/dashboard/warning", data);
  }
  getDashboardStatisticsBH(data: any) {
    return this.get("/guarantee/statistic", data);
  }
  getDashboardStatisticsPP(data: any) {
    return this.get("/qr_aps/dashboard/distribution", data);
  }

// - Thống kê cảnh báo: https://qrcode-test-api.icheck.vn/dashboard/warning?from=2021-01-03&to=2021-01-09&batch_ids=12,13
// - Thống kê tất cả tem: https://qrcode-test-api.icheck.vn/dashboard/overview
// - Thống kê tem bảo hành: https://qrcode-test-api.icheck.vn/guarantee/statistic
// - Thống kê tem phân phối: https://qr-mobile-api.docs.stoplight.io/reference/qr-aps-dashboard-distribution/getqrapsdashboarddistribution
  buyStamp(data) {
    return this.post("/orders", data);
  }
  getLocationSerialScan(serial) {
    return this.get("/dashboard/warning/" + serial);
  }

  // get remind list
  getAlertRepeatTimeList(body: any = null) {
    return this.get("/dashboard/alert-repeat-time", body);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics/StampStatistics.service.ts